<template>
  <v-card flat fill-height class="transparent">
    <v-toolbar flat extended class="pt-3" extension-height="24">
      <div>
        <h4 class="headline">{{ selectedPhoneCall.subject.name }}</h4>
        <span class="subtitle-1 text--secondary">
          Requested:
          <span class="grey--text darken-1">{{ selectedReferral.requested_amount | currency }} | </span>
        </span>
        <span class="subtitle-1 text--secondary pl-1">
          Source:
          <span class="grey--text darken-1" v-if="selectedReferral.referrer">{{ selectedReferral.referrer.name }}</span>
        </span>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon @click="showReferralEdit = true">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">fad fa-edit</v-icon>
          </template>
          <span>Edit referral details</span>
        </v-tooltip>
      </v-btn>
    </v-toolbar>
    <v-tabs background-color="grey lighten-3">
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab>Registration</v-tab>
    </v-tabs>
    <v-container fluid class="px-0 pt-2">
      <v-row dense>
        <v-col cols="6">
          <v-card class="dialler-referral-height">
            <customer-registration
              :referral-details="selectedReferral"
              :phone-call-id="selectedPhoneCall.id"
              :dialler="true"
              :key="selectedReferral.id"
            ></customer-registration>
          </v-card>
        </v-col>
        <v-col cols="6">
          <div class="d-flex flex-column" style="height:100%">
            <v-card class="mb-2">
              <comment-form :referral="selectedReferral"></comment-form>
            </v-card>
            <v-card class="flex-grow-1">
              <comment-list
                :customer="selectedReferral"
                class="ml-2"
                :dialler="true"
                :referral="true"
                :key="selectedReferral.id"
              ></comment-list>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <referral-edit-dialog :referralDetails="selectedReferral" :show.sync="showReferralEdit"></referral-edit-dialog>
  </v-card>
</template>
<script>
import CustomerRegistration from '../Customers/CustomerRegistration/CustomerRegistration';
import CommentList from '../Referrals/Widgets/CommentList';
import CommentForm from '../Referrals/Widgets/CommentForm';
import ReferralEditDialog from '@/components/Platform/Referrals/Widgets/ReferralEditDialog';

export default {
  name: 'DiallerRegistration',
  components: { ReferralEditDialog, CommentForm, CommentList, CustomerRegistration },
  props: {
    selectedPhoneCall: {
      type: Object,
      default: null
    },
    selectedReferral: {
      type: Object,
      default: null
    },
    dialler: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showReferralEdit: false
  }),
  computed: {
    heightClass() {
      return this.dialler ? 'dialler-referral-height' : 'calc-central-height';
    }
  }
};
</script>
<style lang="scss" scoped>
.calc-central-height {
  height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.dialler-referral-height {
  height: calc(97vh - 205px);
  max-height: calc(97vh - 205px);
  overflow-y: auto;
}
</style>
